export var ListGroupDisplay;
(function (ListGroupDisplay) {
    ListGroupDisplay["All"] = "all";
    ListGroupDisplay["Collapsed"] = "collapsed";
    ListGroupDisplay["CollapsedGroup"] = "collapsed_group";
    ListGroupDisplay["Single"] = "single";
})(ListGroupDisplay || (ListGroupDisplay = {}));
//# sourceMappingURL=ListGroupDisplay.js.map